import { FluentStyles } from '@uifabric/fluent-theme/lib/fluent/FluentStyles';
import { orchestrator } from 'satcheljs';
import { isFeatureEnabled, setFeatureFlagAction } from 'owa-feature-flags';
import { Customizations } from '@uifabric/utilities';

export default function loadFluentFabric(
    isFluentEnabled: boolean = isFeatureEnabled('fwk-fluentFabric')
) {
    Object.keys(FluentStyles).forEach(scope => {
        Customizations.applyScopedSettings(scope, isFluentEnabled ? FluentStyles[scope] : {});
    });
}

orchestrator(setFeatureFlagAction, ({ feature, isOn }) => {
    if (feature === 'fwk-fluentFabric') {
        loadFluentFabric(isOn);
    }
});
